import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "WS_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#WS_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "WS_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#WS_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v14h16V0H0z", fill: "#2E42A5" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.566 7.772l-1.06.64.242-1.25-.883-.934 1.196-.05.505-1.166.506 1.166h1.193l-.88.985.265 1.249-1.084-.64zM11.566 7.772l-1.06.64.242-1.25-.883-.934 1.195-.05.506-1.166.506 1.166h1.193l-.88.985.265 1.249-1.084-.64zM7.466 4.138l-.998.602.228-1.175-.83-.88 1.124-.047.476-1.098.476 1.098h1.123l-.829.927.25 1.175-1.02-.602zM8.546 8.425l-.624.377.142-.735-.52-.55.704-.03.298-.685.297.686h.702l-.518.58.156.734-.637-.377zM7.41 12.828l-1.497.904.341-1.763-1.246-1.32 1.687-.071.714-1.646.714 1.646h1.685l-1.244 1.39.375 1.764-1.53-.904z",
      fill: "#FEFFFF"
    }
  )))
), a = t;
export {
  a as default
};
